import React, {useState} from 'react';
 
import { Form, Button, Row, Col, ListGroup, Table } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAlignLeft,faXmark, faFileExce } from "@fortawesome/free-solid-svg-icons"; 
import ImageUploading from 'react-images-uploading';
 
 
 
import Rightbar from './Rightbar';
  
export default function CatalogueImage(){ 
    const [date, setDate] = useState(new Date());
    const [images, setImages] = React.useState([]);
      const maxNumber = 69;
    
      const onChange = (imageList, addUpdateIndex) => {
        // data for submit
        console.log(imageList, addUpdateIndex);
        setImages(imageList);
      };
const [sidebar, setsidebar] = useState(false);
const [mainbar, setmainbar] = useState(false);
const toggle = () => {
    setsidebar(!sidebar);
    setmainbar(!mainbar);
}
return(
  <>
<section className="sec-container" >
   <div className='container'>
      <div className='portalevent'>
         <div className='row'>
            <div className={`col-md-3 portal-sidebar leftbar-close ${sidebar ? 'close' : ''}`}>
                  <div >
                  <Rightbar/>
                  </div>
               </div>
               <div className={`col-md-9 rightbar-open ${mainbar ? 'open' : ''}`}>
                  <div className='rightbar '>
                  <Button variant="outline-info" onClick={toggle}>
                    <FontAwesomeIcon icon={faAlignLeft} />
                  </Button>
                  <h1>OFFICIAL CATALOGUE IMAGE</h1>
                  <div className='gry-bg'>
                            <p>
                                Please upload an image by one artist for your catalogue page. 
                            </p>
                            
                            <p>
                                File Specifications: jpg, sRGB, 300 dpi, {'<='}8MB<br />
                                File names cannot any apostrophes or special characters ({'" @ \ / | : < > *'})
                            </p>
                            </div>
                            <Form>
                                
                                <Form.Group as={Row} controlId="formHorizontalEmail">
                                    <Form.Label column sm={2} >
                                        Artist <span className='star'>*</span>
                                    </Form.Label>
                                    <Col sm={10}>
                                        <Form.Control type="text" placeholder="" />
                                    </Col>
                                </Form.Group>
                                <Form.Group as={Row} controlId="formHorizontalEmail">
                                    <Form.Label column sm={2} >
                                        Title <span className='star'>*</span>
                                    </Form.Label>
                                    <Col sm={10}>
                                        <Form.Control type="text" placeholder="" />
                                    </Col>
                                </Form.Group>
                                <Form.Group as={Row} controlId="formHorizontalEmail">
                                    <Form.Label column sm={2} >
                                        Year <span className='star'>*</span>
                                    </Form.Label>
                                    <Col sm={10}>
                                        <Form.Control type="text" placeholder="" />
                                    </Col>
                                </Form.Group>
                                <Form.Group as={Row} controlId="formHorizontalEmail">
                                    <Form.Label column sm={2} >
                                        Dimensions <span className='star'>*</span>
                                    </Form.Label>
                                    <Col sm={10}>
                                        <Form.Control type="text" placeholder="" />
                                    </Col>
                                </Form.Group>
                                <Form.Group as={Row} controlId="formHorizontalEmail">
                                    <Form.Label column sm={2}  >
                                        Medium <span className='star'>*</span>
                                    </Form.Label>
                                    <Col sm={10}>
                                        <Form.Control type="text" placeholder="" />
                                    </Col>
                                </Form.Group>
                                <Form.Group as={Row} controlId="formHorizontalEmail">
                                    <Form.Label column sm={2}  >
                                        Select File
                                    </Form.Label>
                                    <Col sm={10}>
                                    <ImageUploading
        value={images}
        onChange={onChange}
        maxNumber={maxNumber}
        dataURLKey="data_url"
      >
        {({
          imageList,
          onImageUpload,
          onImageRemoveAll,
          onImageUpdate,
          onImageRemove,
          isDragging,
          dragProps,
        }) => (
          // write your building UI
          <div className="choose-file">
            <button type='button'
              style={isDragging ? { color: 'red' } : undefined}
              onClick={onImageUpload}
              {...dragProps}
            >
           <img src={process.env.PUBLIC_URL+'/images/crop-image.png'}/>
            </button>
 <p>File Specifications: jpg, sRGB, 2MB note: images will be cropped as square</p>
            {imageList.map((image, index) => (
              <div key={index} className="image-item">
                <img src={image['data_url']} alt="" width="100" />
                <div className="image-item__btn-wrapper">
                  <button type='button' onClick={() => onImageUpdate(index)}>Update</button>
                  <button type='button' onClick={() => onImageRemove(index)}>Remove</button>
                </div>
              </div>
            ))}
          </div>
        )}
      </ImageUploading>
                                    </Col>
                                </Form.Group>
                                <br/>
                                <div className='text-center'>
                                <Button className='common-btn'>Submit</Button>
                                </div>
                            </Form>
                            
                  </div>
            </div>
         </div>
      </div>
   </div>
</section>  

 
</>
)
}
